import { useStore } from 'effector-react'
import { useMemo } from 'react'
import { CURRENCY, daysEnumLabels } from '~/shared/config/constants'
import { RentalContractWorkScheduleEnum } from '~/shared/config/enums'
import { formatDateTimeForUI } from '~/shared/lib/date'
import { myPalette } from '~/shared/ui/theme'
import { $paymentSchedule } from './model'
import {
  ListItem,
  ListTitleWrapper,
  List,
  Title,
  Description,
  Block,
  BlockTitle,
  BlockDescription,
  TitleNumberPayments,
  ListItemWrapper,
  BlockWrapper,
} from './staled'

export function WorkSchedule() {
  const paymentSchedule = useStore($paymentSchedule)

  const rentalContract = paymentSchedule?.rentalContract
  const contractNumber = rentalContract?.contractNumber
  const createdAt = rentalContract?.createdAt

  const paymentsTemplateData = paymentSchedule?.paymentsTemplate?.data || []
  const numberPayments = paymentsTemplateData.length

  const getTime = (timeData: string) => {
    const [hours, time] = timeData.split(':')
    return [hours, time].join(':')
  }

  const workScheduleDayOf = useMemo(() => {
    if (
      rentalContract?.workSchedule === RentalContractWorkScheduleEnum.FULL_WEEK
    ) {
      return 'Ежедневно'
    }
    if (
      rentalContract?.workSchedule ===
      RentalContractWorkScheduleEnum.SIX_THROUGH_ONE
    ) {
      const label = rentalContract.dayOff
        ? daysEnumLabels[rentalContract.dayOff]
        : '-'
      return `Выходной (${label})`
    }
  }, [rentalContract?.dayOff, rentalContract?.workSchedule])

  return (
    <>
      <Title>График списаний по договору {contractNumber}</Title>

      {createdAt && (
        <Description>
          Дата заключения договора {formatDateTimeForUI(createdAt)}
        </Description>
      )}

      <BlockWrapper>
        <Block style={{ width: '40%' }}>
          <BlockTitle>График</BlockTitle>
          <BlockDescription>{rentalContract?.workSchedule}</BlockDescription>
        </Block>
        <Block>
          <BlockTitle>Стоимость аренды</BlockTitle>
          <BlockDescription>
            {rentalContract?.rentPerDay &&
              Number(rentalContract?.rentPerDay).toLocaleString()}
            р / сутки
          </BlockDescription>
        </Block>
      </BlockWrapper>

      <TitleNumberPayments>
        {numberPayments
          ? `Платежей в сутки (${numberPayments})`
          : 'График платежей можно будет просмотреть после прохождения осмотра и получения автомобиля.'}
      </TitleNumberPayments>

      {!!numberPayments && (
        <List>
          <ListItemWrapper>
            <ListItem style={{ fontSize: '14px', fontWeight: 600 }}>
              {workScheduleDayOf}
            </ListItem>
          </ListItemWrapper>

          <ListTitleWrapper>
            <ListItem>Время</ListItem>
            <ListItem>Сумма</ListItem>
          </ListTitleWrapper>

          {paymentsTemplateData.map((template, index) => (
            <ListItemWrapper
              key={template.id}
              style={{
                ...(index !== paymentsTemplateData.length - 1
                  ? { borderBottom: `1px solid ${myPalette.blue['500']}` }
                  : {}),
              }}
            >
              <ListItem>{getTime(template.time)}</ListItem>
              <ListItem>
                {template.cost.toLocaleString()}
                {CURRENCY}
              </ListItem>
            </ListItemWrapper>
          ))}
        </List>
      )}
    </>
  )
}
